import { Controller } from "@hotwired/stimulus"

// AB-048 flawless-sync: intercepts clicks on <a> links and submits them
// with an explicit Turbo-Stream Accept header, then feeds the response
// through Turbo.renderStreamMessage. This is needed because Turbo 8's
// native `data-turbo-method="post"` handling on <a> tags treats the
// response as a Turbo Drive page visit rather than a Turbo Stream.
//
// Usage on a link:
//   <a href="/meta/refresh"
//      data-controller="turbo-stream-link"
//      data-action="click->turbo-stream-link#submit"
//      data-turbo-stream-link-method-value="post">
//     Refresh
//   </a>
//
// Works for GET/POST/PATCH/DELETE. CSRF token is read from the <meta>
// tag Rails injects into every layout.
export default class extends Controller {
  static values = {
    method: { type: String, default: "POST" },
    url: { type: String, default: "" }, // falls back to element.href
  }

  connect() {
    console.log(`[turbo-stream-link] connect:`, this.element.tagName, "href=", this.element.href || this.urlValue, "method=", this.methodValue)
  }

  async submit(event) {
    event.preventDefault()
    const url = this.urlValue || this.element.getAttribute("href")
    if (!url) {
      console.error("[turbo-stream-link] no URL (missing href or data-turbo-stream-link-url-value)")
      return
    }

    const method = this.methodValue.toUpperCase()
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    console.log(`[turbo-stream-link] submitting ${method} ${url}`)

    // Immediate visual feedback — disable link + dim
    this.element.classList.add("opacity-50", "pointer-events-none")

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken || "",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "same-origin",
      })

      console.log(`[turbo-stream-link] response: ${response.status} ${response.headers.get("Content-Type")}`)

      if (!response.ok) {
        console.error(`[turbo-stream-link] HTTP ${response.status}`)
        return
      }

      const html = await response.text()
      if (!window.Turbo || !window.Turbo.renderStreamMessage) {
        console.error(`[turbo-stream-link] Turbo.renderStreamMessage unavailable`)
        return
      }

      window.Turbo.renderStreamMessage(html)
      console.log(`[turbo-stream-link] applied ${html.length} bytes of stream`)
    } catch (err) {
      console.error(`[turbo-stream-link] fetch failed:`, err)
    } finally {
      // Re-enable the link after a moment
      setTimeout(() => {
        this.element.classList.remove("opacity-50", "pointer-events-none")
      }, 500)
    }
  }
}
